// Typelizer digest 335c537c32b197adeafebab830e73667
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /categories/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/categories/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /categories */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/categories', {}, options),
    method: 'get',
  }),

  /** POST /categories */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/categories', {}, options),
    method: 'post',
  }),

  /** GET /categories/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/categories/new', {}, options),
    method: 'get',
  }),

  /** GET /categories/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/categories/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /categories/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/categories/:id', params, options),
    method: 'get',
  }),

  /** PATCH /categories/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/categories/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /categories/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/categories/:id', params, options),
    method: 'delete',
  }),
}
